<template>
  <div style="height: 100%">
    <top-toolbar />
    <template-section v-if="section === 'templates'" />
    <dynamic-section v-if="section === 'dynamic'" />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import TopToolbar from './TopToolbar.vue';
import TemplateSection from './TemplateSection.vue';
import DynamicSection from './dynamic-contents/DynamicSection.vue';

export default {
  name: 'EmailDesigner',
  components: {
    TopToolbar,
    TemplateSection,
    DynamicSection
  },
  computed: mapState({
    section: state => state.section
  })
};
</script>

<style></style>
